<div class="container-fluid mt-3 row">
  <div class="form-group justify-content-center col-md-6">
    <h3>Gérer les biens de démos</h3>
    <mat-form-field class="mr-2 w-100">
      <mat-label>Uid du bien</mat-label>
      <input matInput required placeholder="" [formControl]="demoUid" />
      <mat-error>
        <span *ngIf="demoUid.hasError('required')">Saisie obligatoire</span>
      </mat-error>
    </mat-form-field>
    <div class="text-center">
      <button mat-flat-button class="m-2" color="primary" [disabled]="demoUid.hasError('required')"
        (click)="confirmAddDemoProperty()">
        Ajouter
      </button>
      <button mat-flat-button class="m-2" color="primary" [disabled]="demoUid.hasError('required')"
        (click)="confirmRemoveDemoProperty()">
        Supprimer
      </button>
    </div>
  </div>
  <div class="form-group justify-content-center col-md-6">
    <h3>Exporter un bien</h3>
    <mat-form-field class="mr-2 w-100">
      <mat-label>Uid du bien</mat-label>
      <input matInput required placeholder="" [formControl]="exportUid" />
      <mat-error>
        <span *ngIf="exportUid.hasError('required')">Saisie obligatoire</span>
      </mat-error>
    </mat-form-field>
    <div class="text-center">
      <button mat-flat-button class="m-2" color="primary" [disabled]="exportUid.hasError('required')"
        (click)="confirmExportProperty()">
        Exporter
      </button>
    </div>
  </div>
  <div class="form-group justify-content-center col-md-6">
    <h3>Importer un bien</h3>
    <p>Fichier archive</p>
    <input type="file" accept="application/zip" #importFile required
      (change)="importFileSelected($event.target.files)" />
    <div class="text-center">
      <button mat-flat-button class="m-2" color="primary" [disabled]="!importFile.value"
        (click)="confirmImportProperty()">
        Importer
      </button>
    </div>
  </div>
  <div class="form-group justify-content-center col-md-6">
    <h3>Exporter les utilisateurs</h3>
    <div class="text-center">
      <mat-form-field class="mr-2 w-100">
        <mat-label>Type d'utilisateur</mat-label>
        <mat-select [(value)]="exportUserRole">
          <mat-option [value]="null">Tous</mat-option>
          <mat-option *ngFor="let role of exportUserRoles" [value]="role">{{role}}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-flat-button class="m-2" color="primary" (click)="confirmExportUser()">
        Exporter les utilisateurs
      </button>
    </div>
  </div>
  <div class="form-group justify-content-center col-md-6">
    <h3>Synchoniser les droits</h3>
    <div class="text-center">
      <button mat-flat-button class="m-2" color="primary" (click)="confirmSyncRights()">
        Synchoniser
      </button>
    </div>
  </div>
  <div class="form-group justify-content-center col-md-6">
    <h3>Voir les messages d'intro</h3>
    <div>
      <mat-form-field class="mr-2 w-100">
        <mat-label>Type d'utilisateur</mat-label>
        <mat-select [(value)]="introUser">
          <mat-option *ngFor="let user of introUsers" [value]="user">{{user}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="text-center">
      <button mat-flat-button class="m-2" color="primary" (click)="showIntroUser()">
        Voir
      </button>
    </div>
  </div>


</div>